__turbopack_context__.v({
  "activityFilterDropdown": "MemeLab-module-scss-module__AfRgXG__activityFilterDropdown",
  "artFormatLabel": "MemeLab-module-scss-module__AfRgXG__artFormatLabel",
  "artHeader": "MemeLab-module-scss-module__AfRgXG__artHeader",
  "artHeaderContent": "MemeLab-module-scss-module__AfRgXG__artHeaderContent",
  "arweaveLink": "MemeLab-module-scss-module__AfRgXG__arweaveLink",
  "collectionLink": "MemeLab-module-scss-module__AfRgXG__collectionLink",
  "disabled": "MemeLab-module-scss-module__AfRgXG__disabled",
  "fullScreen": "MemeLab-module-scss-module__AfRgXG__fullScreen",
  "hodlersTable": "MemeLab-module-scss-module__AfRgXG__hodlersTable",
  "hodlersTableLive": "MemeLab-module-scss-module__AfRgXG__hodlersTableLive",
  "main": "MemeLab-module-scss-module__AfRgXG__main",
  "mainContainer": "MemeLab-module-scss-module__AfRgXG__mainContainer",
  "marketplace": "MemeLab-module-scss-module__AfRgXG__marketplace",
  "memePageTab": "MemeLab-module-scss-module__AfRgXG__memePageTab",
  "memePageTabActive": "MemeLab-module-scss-module__AfRgXG__memePageTabActive",
  "memesCarousel": "MemeLab-module-scss-module__AfRgXG__memesCarousel",
  "nftImagePadding": "MemeLab-module-scss-module__AfRgXG__nftImagePadding",
  "nftImageWrapper": "MemeLab-module-scss-module__AfRgXG__nftImageWrapper",
  "overviewColumn": "MemeLab-module-scss-module__AfRgXG__overviewColumn",
  "overviewColumnNote": "MemeLab-module-scss-module__AfRgXG__overviewColumnNote",
  "rankSubheading": "MemeLab-module-scss-module__AfRgXG__rankSubheading",
  "season": "MemeLab-module-scss-module__AfRgXG__season",
  "sort": "MemeLab-module-scss-module__AfRgXG__sort",
  "sortDirection": "MemeLab-module-scss-module__AfRgXG__sortDirection",
  "tab": "MemeLab-module-scss-module__AfRgXG__tab",
  "tabFocus": "MemeLab-module-scss-module__AfRgXG__tabFocus",
  "tabFocusActive": "MemeLab-module-scss-module__AfRgXG__tabFocusActive",
  "theArtImage": "MemeLab-module-scss-module__AfRgXG__theArtImage",
  "transactionsScrollContainer": "MemeLab-module-scss-module__AfRgXG__transactionsScrollContainer",
  "transactionsTable": "MemeLab-module-scss-module__AfRgXG__transactionsTable",
  "volumeDropdown": "MemeLab-module-scss-module__AfRgXG__volumeDropdown",
  "volumeDropdownEnabled": "MemeLab-module-scss-module__AfRgXG__volumeDropdownEnabled",
});
